import React from 'react';
import PropTypes from 'prop-types';

import "./Radio.css";

export class Radio extends React.Component {
  constructor(props) {
    super(props);

    this.handleOptionChange = this.handleOptionChange.bind(this);
  }

  handleOptionChange(e) {
    let value= e.target.value;
    this.props.onChange(value);
  }

  renderOption(option){
    return (
    <div className="form-check form-check-inline" key={option.id}>
      <input className="form-check-input" type="radio"
             name={this.props.name} id={option.id} value={option.value}
             disabled={this.props.readOnly}
             onChange={this.handleOptionChange}
             checked={this.props.value === option.value}/>
      <label className="form-check-label" htmlFor={option.id}>
        {option.label}
      </label>
    </div>
    );
  }

  render() {
    let {label, options} = this.props;
    return (
        <div className="tds-radio">
          <span className="tds-radio-label">{label}</span>
          {options.map((option) => this.renderOption(option))}
        </div>
    );
  }
};

Radio.propTypes = {
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  readOnly: PropTypes.bool,
  value: PropTypes.any,
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired
};